const wechat = {
  state: {
    isConfig: false,
    position: {},
    address: '',
    addressHistory: []
  },
  mutations: {
    complateConfig(state) {
      state.isConfig = true
    },
    setPosition(state, pos) {
      state.position = pos
    },
    setAddress(state, addr) {
      state.address = addr
    },
    setAddressHistory(state, addressHistory) {
      state.addressHistory = addressHistory
    }
  },
  action: {}
}

export default wechat
